var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _g3, _path9, _path10, _path11, _path12, _path13, _g4, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g5, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoArticles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 480 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Empty/Library/no articles"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3781",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 2,
    width: 174,
    height: 410
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 2H227.295V411.27H54V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.17 370.647L81.4888 410.338C67.8051 414.494 54 404.235 54 389.911V23.3602C54 8.92956 67.9963 -1.34242 81.7307 3.00846L212.412 44.4046C221.273 47.2121 227.295 55.4477 227.295 64.757V350.22C227.295 359.623 221.153 367.919 212.17 370.647Z",
    fill: "black"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.273 50.3481C163.273 53.6726 161.426 56.3674 159.148 56.3674C156.87 56.3674 155.023 53.6726 155.023 50.3481C155.023 47.0237 156.87 44.3289 159.148 44.3289C161.426 44.3289 163.273 47.0237 163.273 50.3481Z",
    fill: "#697079"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.945 53.21C171.945 55.2794 170.795 56.9574 169.377 56.9574C167.959 56.9574 166.809 55.2794 166.809 53.21C166.809 51.1407 167.959 49.4626 169.377 49.4626C170.795 49.4626 171.945 51.1407 171.945 53.21Z",
    fill: "#697079"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1112 50.6433V355.855L224.939 321.623V86.347L73.1112 50.6433Z",
    fill: "#774331"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 127",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1113 317.93L224.939 292.229V284.803L73.1113 308.304V317.93Z",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 129",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.938 166.473L73.111 154.913V164.295L224.938 173.711V166.473Z",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 131",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.938 226.543L73.111 232.782V242.107L224.938 233.737V226.543Z",
    fill: "#B26E4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 133",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1113 88.3826L224.939 115.15V107.853L73.1113 78.9221V88.3826Z",
    fill: "#B26E4B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 34"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.915 470.373V462.276L327.361 462.162L327.091 474.66L309.404 487.571L301.915 470.373Z",
    fill: "#C962A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.465 470.373V462.276L386.91 462.162L386.64 474.66L368.954 487.571L361.465 470.373Z",
    fill: "#C962A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.41 99.43C295.41 99.43 294.485 101.397 294.418 100.251C290.26 98.5725 294.825 91.1312 292.349 86.2659C290.963 83.5414 290.149 80.6752 289.865 77.8664C291.014 77.3317 292.164 76.8012 293.318 76.2784L295.411 74.3445C300.222 71.3168 306.294 71.6896 308.98 72.9515C318.481 77.4137 309.063 87.7636 309.856 87.4437C306.27 91.8137 295.41 99.43 295.41 99.43Z",
    fill: "#EFB87B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_3781",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 254,
    y: 75,
    width: 61,
    height: 114
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M314.617 187.426L256.349 188.443L254.389 76.1857L312.657 75.1687L314.617 187.426Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_3781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.099 104.969C253.856 114.656 252.627 129.268 260.127 140.284L295.622 193.256C299.746 199.313 301.078 188.411 307.207 184.186C313.113 180.114 317.402 168.676 313.402 162.8C313.402 162.8 318.37 150.137 316.682 146.852C316.06 145.644 307.906 147.445 307.208 146.528C301.162 138.581 283.591 123.617 283.591 123.617L305.512 96.8431C304.081 90.8215 298.829 82.4647 292.037 75.5286L263.099 104.969Z",
    fill: "#47C2BB"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.309 497.675L386.641 474.66L378.41 480.376C378.41 480.376 382.767 470.373 361.465 470.373C360.873 477.659 356.11 483.975 349.193 486.645L334.229 490.482C333.553 490.795 333.071 491.394 332.886 492.097L332.802 497.812H387.401L387.309 497.675Z",
    fill: "#5E3A30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.361 139.007L349.041 105.324L327.385 91.7319L325.967 143.73C307.889 150.575 305.469 157.708 305.469 171.533L372.764 166.682C372.764 152.858 370.932 141.406 349.361 139.007Z",
    fill: "#EFB87B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.444 140.962C356.077 139.956 352.67 139.223 349.361 138.855L323.879 159.229L325.013 143.254C323.515 143.661 322.067 144.1 320.666 144.566C320.871 144.252 306.527 147.076 306.739 146.765C287.669 152.281 298.648 160.208 295.625 171.533C272.656 239.037 297.009 271.272 297.009 271.272L382.768 271.272C382.768 271.272 391.191 161.207 387.672 157.635C379.685 147.602 371.044 143.156 359.444 140.962Z",
    fill: "#47C2BB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.194 462.514H387.251C387.251 462.514 382.767 396.305 382.767 271.272H297.009C287.391 331.288 300.001 462.531 300.001 462.531H328.669L333.374 332.003H341.415C344.887 391.96 355.194 462.514 355.194 462.514Z",
    fill: "#454545"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_3781",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 268,
    y: 470,
    width: 60,
    height: 28
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.41 470.373H327.851V498H268.41V470.373Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_3781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.844 497.812H327.851L327.844 497.804L327.091 474.66L309.178 480.376C309.178 480.376 311.18 470.757 301.915 470.373C301.323 477.659 296.56 483.975 289.644 486.645L269.838 490.482C269.162 490.795 268.68 491.394 268.496 492.096L268.41 497.812H321.994L327.851 498L327.844 497.812Z",
    fill: "#5E3A30"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.805 82.2837L354.929 84.4151L349.195 121.465L342.991 102.947L328.67 100.75L335.805 82.2837Z",
    fill: "#78868E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.991 102.947C345.274 116.974 332.517 129.457 323.434 130.888C314.352 132.318 312.463 123.725 309.637 107.012C308.284 98.9967 306.667 92.8396 310.38 85.939C314.094 79.0384 319.095 78.437 323.778 76.7883C341.678 78.3102 338.562 92.3078 334.967 94.3216L342.991 102.947Z",
    fill: "#EFB87B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M297.907 71.8352L299.184 74.6813C299.184 74.6813 323.409 76.0358 329.155 81.305C334.099 85.8378 349.31 91.3641 353.457 92.8175C354.024 93.016 354.634 92.6919 354.778 92.1188L357.582 80.9381C358.588 76.9284 356.117 72.8518 352.054 71.7857C325.959 64.9326 306.703 67.2331 299.651 68.5341C298.124 68.816 297.275 70.4288 297.907 71.8352Z",
    fill: "#5E3A30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.177 113.261C319.128 113.269 319.076 113.269 319.023 113.26C318.915 113.243 316.381 112.817 315.261 111.283C314.196 109.822 314.846 101.734 314.986 100.127C315.01 99.8651 315.246 99.6708 315.511 99.6943C315.777 99.7168 315.974 99.9469 315.952 100.21C315.613 104.058 315.419 109.866 316.048 110.727C316.785 111.738 318.559 112.22 319.179 112.32C319.444 112.363 319.622 112.609 319.579 112.869C319.544 113.075 319.378 113.23 319.177 113.261Z",
    fill: "#EFB87B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.071 109.427C322.671 109.577 318.952 106.174 318.783 101.842C318.613 97.5096 322.055 93.8641 326.455 93.714C330.856 93.5639 334.574 96.9655 334.744 101.298C334.914 105.63 331.472 109.277 327.071 109.427ZM304.823 110.185C300.422 110.335 296.704 106.933 296.534 102.601C296.364 98.269 299.807 94.6224 304.207 94.4724C308.607 94.3222 312.325 97.7248 312.495 102.057C312.665 106.388 309.223 110.035 304.823 110.185ZM326.399 92.2851C321.198 92.4626 317.131 96.7723 317.332 101.892C317.339 102.052 317.36 102.208 317.375 102.367L313.94 102.484C313.942 102.325 313.953 102.168 313.946 102.008C313.746 96.8873 309.351 92.8669 304.151 93.0435C298.95 93.221 294.883 97.5307 295.083 102.651C295.284 107.77 299.678 111.791 304.878 111.614C309.416 111.459 313.09 108.158 313.82 103.919L317.608 103.789C318.668 107.968 322.59 111.009 327.127 110.856C332.327 110.678 336.396 106.368 336.195 101.248C335.994 96.1289 331.6 92.1076 326.399 92.2851Z",
    fill: "#3B3F41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 26_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.187 271.272H353.356C355.097 265.293 363.338 258.354 363.338 258.354C363.338 258.354 369.556 253.885 370.115 255.02C375.026 254.936 373.617 264.454 378.199 268.329C380.765 270.5 382.815 273.06 384.306 275.789C383.376 276.827 382.445 277.86 381.506 278.886L379.236 281.351L379.256 281.367C378.469 282.607 374.146 286.296 373.181 287.266C373.181 287.266 365.649 280.136 362.187 271.272Z",
    fill: "#EFB87B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 30_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_3781",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 360,
    y: 153,
    width: 64,
    height: 125
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 29_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.184 153.624H424V277.464H360.184V153.624Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_3781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 28_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.767 277.464L415.014 245.553C425.319 235.048 426.944 218.957 418.942 206.663L388.093 158.384C383.694 151.625 375.026 152.798 368.235 157.339C361.69 161.717 357.682 175.644 361.949 182.201L392.934 224.592L368.421 253.698C369.874 260.367 375.463 269.684 382.767 277.464Z",
    fill: "#47C2BB"
  })))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.039 144.333L316.682 172.912L324.034 159.496L332.174 175.294L354.929 140.047L349.12 134.807L324.912 155.764L325.88 138.617L321.039 144.333Z",
    fill: "#FFCC66"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoArticles);
export default __webpack_public_path__ + "static/media/NoArticles.a595d1e66200bd686a8202219fb2459d.svg";
export { ForwardRef as ReactComponent };